import type { FormField } from '@/types/api/form'
import { FormFieldType } from '@/types/enums'

import { pageBreakTitle } from './layoutField'

export interface FormStep<T> {
  title: string
  fields: T[]
}

/**
 * Splits a form's fields (already in order) into steps at its page breaks. A page break names the
 * step that follows it; the break itself is not part of any step and empty steps are dropped.
 */
export function splitIntoSteps<T extends Pick<FormField, 'type' | 'options'>>(fields: readonly T[]): FormStep<T>[] {
  const steps: FormStep<T>[] = []
  let current: FormStep<T> = { title: '', fields: [] }
  for (const field of fields) {
    if (field.type === FormFieldType.PAGE_BREAK) {
      if (current.fields.length > 0) steps.push(current)
      current = { title: pageBreakTitle(field), fields: [] }
    } else {
      current.fields.push(field)
    }
  }
  if (current.fields.length > 0) steps.push(current)
  return steps
}
